import './App.css';
import MainContent from './components/MainContent';

function App() {
  //In the future a SideBar might be used here
  return (
    <div className='app'>
      <MainContent />
    </div>
  );
}

export default App;
